module.exports = productlistRemote;